import React, { useEffect, useState } from "react";
import "./LoanTab.scss";
import LoanDetailModal from "../LoanTable/LoanDetailModal";
import { useSelector } from "react-redux";
import {
  TableHead,
  TableBody,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  Box,
  Pagination,
  Button,
  FormControl,
  Autocomplete,
  TextField,
  Typography,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import CustomInputAlert from "../UI/CustomInputAlert/CustomInputAlert";
import RegistrationSelect from "../UI/Registration/RegistrationSelect";
import RegistrationInput from "../UI/Registration/RegistrationInput";
import InternationalTransferFooterButtons from "../AccountActionsComponents/UserAccountTransfers/InternationalTransfers/InternationalTransferFooterButtons";
import {
  checkLoanEligibility,
  addLoanLimit,
  loanOptIn,
  loanOptOut,
  loanRequest,
  loanRequestOnly,
  listAllUserLoanProducts,
  listProductsAssignedToUsers,
  retrieveExtCode,
  registerExtID2,
} from "../../util/API/loans";
import AddIcon from "@mui/icons-material/Add";
import LoadingPage from "../UI/LoadingPage/LoadingPage";
import LoanProductsAssignedTable from "../LoanProductsAssignedTable/LoanProductsAssignedTable";
import LoanCreateNew from "../LoanCreateNew/LoanCreateNew";
import LoanProductsAssign from "../LoanProductsAssign/LoanProductsAssign";
import LoanAssignmentPage from "../LoanAssignmentPage/LoanAssignmentPage";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import LoanDetails4Pay from "../LoanDetails4Pay/LoanDetails4Pay";
import LoanProductInfo from "../LoanProductInfo/LoanProductInfo";
import LoanApprovalPage from "../LoanApprovalPage/LoanApprovalPage";
import LoansApprovedPage from "../LoansApprovedPage/LoansApprovedPage";
import LoanPaymentsPage from "../LoanPaymentsPage/LoanPaymentsPage";
import LoanPaymentViewCancel from "../LoanPaymentViewCancel/LoanPaymentViewCancel";
import LoanUserReportsView from "../LoanUserReportsView/LoanUserReportsView";
import LoanPaymentView from "../LoanPaymentView/LoanPaymentView";
import LoanLimitHistory from "../LoanLimitHistory/LoanLimitHistory";
import LoansCancelledRequests from "../LoansCancelledRequests/LoansCancelledRequests";
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PreQualificationScreening from "../PreQualificationScreening/PreQualificationScreening";
import UnderwritingCreditAssessment from "../UnderwritingCreditAssessment/UnderwritingCreditAssessment";
import ApprovalLoanRequest from "../ApprovalLoanRequest/ApprovalLoanRequest";
import LoanRequestDisbursement from "../LoanRequestDisbursement/LoanRequestDisbursement";

function LoansTab4Pay({ selectedUser, selectedUserData }) {
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loanList, setLoanList] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [selectedLoan, setSelectedLoan] = useState(null);
  const [tablePages, setTablePages] = useState(0);

  const [isEligible, setEligible] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [landingPage, setLandingPage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedProductEligiblity, setSelectedProductEligiblity] =
    useState(null);
  const [selectedProductLoan, setSelectedProductLoan] = useState(null);
  const [selectedProductLoanId, setSelectedProductLoanId] = useState(null);
  const [selectedLoanProductArray, setSelectedLoanProductArray] = useState(null);
  const [selectedCurrencyCode, setSelectedCurrencyCode] = useState(null);
  const [maxAmtInputError, setMaxAmtInputError] = useState("");
  const [maxEligibleAmt, setMaxEligibleAmt] = useState("");
  const [loanAmt, setLoanAmt] = useState("");
  const [createNewLoan, setCreateNewLoan] = useState(false);
  const [isLoanProductSelected, setIsLoanProductSelected] = useState(false);
  const [viewReports, setViewReports] = useState(false);
  const [viewLimitHistory, setViewLimitHistory] = useState(false);
  const [viewPreQualificationScreening, setViewPreQualificationScreening] = useState(false);
  const [viewUnderwritingCreditAssessment, setViewUnderwritingCreditAssessment] = useState(false);
  const [viewApprovalLoanRequest, setViewApprovalLoanRequest] = useState(false);
  const [viewLoanRequestDisbursement, setViewLoanRequestDisbursement] = useState(false);
  
  // Dummy Data to send to api
  const [sampleloantype, setSampleloantype] = useState(1);
  const [sampleloanamount, setSampleloanamount] = useState(1);
  const [
    sampleloanamountforfeecalculation,
    setSampleloanamountforfeecalculation,
  ] = useState(1);
  const [sampletermtype, setSampletermtype] = useState(0);
  const [refid, setRefid] = useState(1);
  const [returnoutstandingloans, setReturnoutstandingloans] = useState(1);
  const [intent, setIntent] = useState("");
  // =====================================================  //

  const [loanAssignment, setLoanAssignment] = useState(false);
  const [payments, setPayments] = useState(false);
  const [viewCancelPayments, setViewCancelPayments] = useState(false);
  const [viewPayments, setViewPayments] = useState(false);
  const [loanApproval, setLoanApproval] = useState(false);
  const [viewApprovedLoans, setViewApprovedLoans] = useState(false);
  const [viewCancelledLoans, setViewCancelledLoans] = useState(false);
  const [products, setProducts] = useState([]);
  const [productsAssignedToUsers, setProductsAssignedToUsers] = useState([]);
  const [errors, setErrors] = useState({ product: false, maxAmount: false });
  const [openLoanDetailsDrawer, setOpenLoanDetailsDrawer] = useState(false);
  const [openLoanProductInfoDrawer, setOpenLoanProductInfoDrawer] = useState(false);
  const [loanProductDetails, setLoanProductDetails] = useState(null);
  const [loanType, setLoanType] = useState(null);
  
  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "",
    header: "",
    message: "",
    onConfirm: null,
    alertType: ''
  });

  // async function getLoanInfo() {
  //   try {
  //     let response = await checkLoanEligibility(
  //       "",
  //       selectedUser,
  //       selectedUserData?.User?.defaultcurrency,
  //       sampleloantype,
  //       sampleloanamount,
  //       sampleloanamountforfeecalculation,
  //       sampletermtype,
  //       refid,
  //       returnoutstandingloans,
  //       intent
  //     );

  //     if (response?.payload?.callStatus === "0") {
  //       setEligible(false);
  //     } else {
  //       setEligible(true);
  //     }
  //   } catch (error) {
  //     setIsLoading(false);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }

  const getLoanProducts = async () => {
    try {
      let response = await listAllUserLoanProducts(226, selectedUser);
      if (
        response?.data?.header?.callStatus === "1" &&
        response?.data?.header?.reccount !== "0"
      ) {
        const loanProductsArray = Array.isArray(response?.data?.body?.record)
          ? response?.data?.body?.record
          : [response?.data?.body?.record];
        const formatedArr = loanProductsArray.map((item, index) => ({
          key: item.loanproducts.productid,
          value: item.loanproducts.productid,
          label: item.loanproducts.name,
        }));
        console.log("getLoanProducts_responseee-------------", formatedArr);
        setProducts(formatedArr);
      } else if (response?.data?.header?.reccount === "0") {
        setProducts([]);
      }
    } catch (error) {
      console.log("getLoanProducts_error-------------", error);
    } finally {
      setIsLoading(false);
    }
  };

  const getProductsAssignedToUsers = async () => {
    console.log("getProductsAssignedToUsers called--------------")
    try {
      let response = await listProductsAssignedToUsers(225, selectedUser);

      if (
        response?.data?.header?.callStatus === "1" &&
        response?.data?.header?.reccount !== "0"
      ) {
        const loanProductsArray = Array.isArray(response?.data?.body?.record)
          ? response?.data?.body?.record
          : [response?.data?.body?.record];
        console.log(
          "getProductsAssignedToUsers_responseee---------------===",
          loanProductsArray
        );
        setProductsAssignedToUsers(loanProductsArray);
      } else if (response?.data?.header?.reccount === "0") {
        setProductsAssignedToUsers([]);
      }
    } catch (error) {
      console.log("getProductsAssignedToUsers_errors----------------", error);
    }
  };

  useEffect(() => {
    console.log("selectedUser----------", selectedUser);
    console.log("selectedUserData----------", selectedUserData);

    // getLoanInfo();
    getLoanProducts();
    getProductsAssignedToUsers();
  }, [selectedUser]);

  const handleEligiblityProductChange = (event, newValue) => {
    console.log("newValue-------------", newValue);
    setSelectedProductEligiblity(newValue);
  };

  const handleMaxEligibleAmtChange = (e) => {
    setMaxEligibleAmt(e.target.value);
  };

  const handleMakeUserEligible = async (vals) => {
    // console.log("e----------=====", e);
    // console.log("submittedData----------=======", submittedData);
    console.log("vals----------", vals);
    console.log("selectedUser----------======", selectedUser);

    try {
      setErrors({
        product: false,
        maxAmount: false,
      });

      const registerExtId = await checkIfUserExtRegistered();

      console.log("next----------======", registerExtId);

      if(registerExtId) {
        if (
          !vals?.addproduct ||
          vals?.maxeligibleamount === "" ||
          vals?.maxeligibleamount === "0"
        ) {
          setErrors({
            product: !vals?.addproduct,
            maxAmount: vals?.maxeligibleamount === "" || vals?.maxeligibleamount === "0",
          });
          return;
        }
        setIsLoading(true);
        
  
        let response = await addLoanLimit(
          "",
          selectedUser,
          vals?.addproduct,
          vals?.maxeligibleamount,
          1
        );

        console.log("handleMakeUserEligible1-----------------",response);
  
        if (response?.data?.header?.callStatus === "1") {
          let optInResponse = await loanOptIn(
            "",
            selectedUser,
            vals?.addproduct,
            1,
            ""
          );

          console.log("handleMakeUserEligible2-----------------",optInResponse);
  
          if (optInResponse?.data?.header?.callStatus === "1") {
            setEligible(true);
            getLoanProducts();
            getProductsAssignedToUsers();
            setSelectedProductEligiblity(null);
            setMaxEligibleAmt("");
            setAlert({
              showAlert: true,
              severity: "success",
              message:
              "The user is eligible for a loan and has successfully opted in.",
              header: "Congratulations!",
            });
            setAlertOpen(true);
          }
        } else {
          setEligible(false);
        }
        setIsLoading(false);
      } else {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Failed to register extID",
          header: "Error!",
        });
      }
    } catch (error) {
      console.log("handleMakeUserEligible_error----------", error);
      setIsLoading(false);
    }
  };

  const checkIfUserExtRegistered = async() => {
    try {
      let response = await retrieveExtCode(2, selectedUser);
      console.log("checkIfUserExtRegistered_response----------", response);

      if(response?.data?.header?.callStatus == "1") {
        return true;
      } else if(response?.Status == "2" && response?.payload?.callStatus == "0") {
        let response2 = await registerExtID2("", 2, selectedUser, selectedUser, 1, 0);
        console.log("checkIfUserExtRegistered_response2----------", response2);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log("checkIfUserExtRegistered_error----------", error);
      setIsLoading(false);
      return false;
    }

  }

  // const handleLoanProductChange = (event, newValue) => {
  //   console.log("newValue============", newValue);
  //   setSelectedProductLoan(newValue);
  // };

  const handleLoanAmtChange = (e) => {
    setLoanAmt(e?.target?.value);
  };

  const handleCreateNewLoan = async () => {
    try {
      let response = await loanRequestOnly(
        "",
        selectedUser,
        selectedUserData?.User?.defaultcurrency,
        1,
        loanAmt,
        1,
        1,
        0
        // 2018 - 10 - 21,
        // 1,
        // "",
        // "",
        // 0,
        // 1
      );

      if (response?.data?.header?.callStatus === "1") {
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Loan created successfully.",
          header: "Congratulations!",
        });
        setAlertOpen(true);
      }

      setCreateNewLoan(false);
      setLoanAmt("");
      setSelectedProductLoan(null);

      console.log("handleCreateNewLoan_responseeeee-------------", response);
    } catch (error) {
      console.log("handleCreateNewLoan_error-------------", error);
      setIsLoading(false);
    } finally {
      setIsLoading(false);
    }
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "rgba(0,0,0, .1)",
      color: theme.palette.common.black,
      fontWeight: "bold",
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 25,
      fontWeight: "600",
    },
  }));

  const handleOptOutConfirmation = async(rowData) => {
    console.log("rowDataaaaa-------------", rowData);
    try {
      let response = await loanOptOut( "", selectedUser, rowData?.productcode, 1 );
      console.log("handleOptOutConfirmation_response-----------",response)
      if(response?.data?.header?.callStatus === "1") {
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Opted out successfully!.",
          header: "Congratulations!",
        });
        setAlertOpen(true);
      } else if(response?.Status === "2") {
        setAlert({
          showAlert: true,
          severity: "error",
          message: response?.payload?.msg,
          header: "Error!",
        });
      }
    } catch (error) {
      console.log("handleOptOutConfirmation_error-------------", error);
    }
    finally {
      setIsLoading(false);
    }
  }

  const handleOptInConfirmation = async(rowData) => {
    try {
      // let response = await loanOptOut( "", selectedUser, rowData?.productcode, 1 );
      let response = await loanOptIn(
        "",
        selectedUser,
        rowData?.productcode,
        1,
        ""
      );
      console.log("handleOptInConfirmation_response-----------",response);
      if(response == undefined) {
        setAlert({
          showAlert: true,
          severity: "error",
          message: "Something went wrong.",
          header: "Error Code - 500",
        });
      }

      if(response?.data?.header?.callStatus === "1") {
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Opted in successfully!.",
          header: "Congratulations!",
        });
        setAlertOpen(true);
      } else if(response?.Status === "2") {
        setAlert({
          showAlert: true,
          severity: "error",
          message: response?.payload?.msg,
          header: "Error!",
        });
      }
    } catch (error) {
      console.log("handleOptOutConfirmation_error-------------", error);
    }
    finally {
      setIsLoading(false);
    }
  }

  const handleLoanOptOut = async(rowData) => {
    try {
      setAlert({
        ...alert,
        showAlert: true,
        message: "Are you sure you want to opt out?",
        severity: "confirm",
        header: "Please Confirm",
        alertType: 'confirm',
        onConfirm: () => handleOptOutConfirmation(rowData)
      })
    } catch (error) {
      console.log("handleLoanOptOut_error-------------", error);
    }
    finally {
      setIsLoading(false);
    }
  }

  const handleLoanOptIn = async(rowData) => {
    try {
      setAlert({
        ...alert,
        showAlert: true,
        message: "Are you sure you want to opt in?",
        severity: "confirm",
        header: "Please Confirm",
        alertType: 'confirm',
        onConfirm: () => handleOptInConfirmation(rowData)
      })
    } catch (error) {
      console.log("handleLoanOptOut_error-------------", error);
    }
    finally {
      setIsLoading(false);
    }
  }

  const handleMoreInfo = async(rowData) => {
    console.log("handleMoreInfo==========",rowData);
    try {
      let response = await checkLoanEligibility(
        "",
        selectedUser,
        rowData?.productcode,
        sampleloantype,
        sampleloanamount,
        sampleloanamountforfeecalculation,
        sampletermtype,
        refid,
        returnoutstandingloans,
        intent
      );
      
      
      console.log("handleMoreInfo_response-------------", response);
      if (response?.data?.header?.callStatus === "1") {
        setLoanProductDetails(response?.data?.header?.limits?.limit);
        setOpenLoanProductInfoDrawer(true);
      }
      // let response = await loanOptIn( "", selectedUser, rowData?.currencycode, 1, "" );
      // console.log("handleLoanOptOut_response-----------",response)

    } catch (error) {
      console.log("handleLoanOptOut_error-------------", error);
    }
    finally {
      setIsLoading(false);
    }
  }

  const handleApproveLoans = async(rowData) => {
    console.log("handleApproveLoans_rowData-------------", rowData);
    setLoanApproval(true);
  }

  const handleApprovedLoans = async(rowData) => {
    console.log("handleApprovedLoans_rowData-------------", rowData);
    setViewApprovedLoans(true);
  }

  if (isLoading) {
    return <LoadingPage />;
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setAlertOpen(false);
  };

  return (
    <Box className="loans-tab-4pay-container">
      {isLoanProductSelected && !createNewLoan ? (
        <Box></Box>
      ) : createNewLoan === true ? (
        <LoanCreateNew
          setCreateNewLoan={setCreateNewLoan}
          // products={products}
          selectedProductLoan={selectedProductLoan}
          // handleLoanProductChange={handleLoanProductChange}
          // loanAmt={loanAmt}
          handleLoanAmtChange={handleLoanAmtChange}
          maxAmtInputError={maxAmtInputError}
          handleCreateNewLoan={handleCreateNewLoan}
          setAlert={setAlert}
          setAlertOpen={setAlertOpen}
          selectedUser={selectedUser}
          setSelectedProductLoan={setSelectedProductLoan}
          setIsLoading={setIsLoading}
          selectedProductLoanId={selectedProductLoanId}
          selectedCurrencyCode={selectedCurrencyCode}
          loanType={loanType}
          getProductsAssignedToUsers={getProductsAssignedToUsers}
          selectedLoanProductArray={selectedLoanProductArray}
          selectedProductEligiblity={selectedProductEligiblity}
        />
      ) : loanAssignment === true ? (
        <LoanAssignmentPage
          setLoanAssignment={setLoanAssignment}
          setOpenLoanDetailsDrawer={setOpenLoanDetailsDrawer}
          openLoanDetailsDrawer={openLoanDetailsDrawer}
        />
      ) : loanApproval === true ? (
        <LoanApprovalPage
          setLoanApproval={setLoanApproval}
          selectedProductLoan={selectedProductLoan}
          selectedUser={selectedUser}
          setAlert={setAlert}
          getProductsAssignedToUsers={getProductsAssignedToUsers}
          setAlertOpen={setAlertOpen}
        />
      ) : viewApprovedLoans === true ? (
        <LoansApprovedPage
          setViewApprovedLoans={setViewApprovedLoans}
          selectedProductLoan={selectedProductLoan}
          selectedUser={selectedUser}
          setAlert={setAlert}
          setAlertOpen={setAlertOpen}
        />
      ) : viewCancelledLoans === true ? (
        <LoansCancelledRequests
          selectedProductLoan={selectedProductLoan}
          selectedUser={selectedUser}
          setAlert={setAlert}
          setViewCancelledLoans={setViewCancelledLoans}
        />
      ): payments === true ? 
      (
        <LoanPaymentsPage setPayments={setPayments} setIsLoading={setIsLoading} selectedProductLoan={selectedProductLoan} selectedUser={selectedUser} setAlertOpen={setAlertOpen} />
      ) : viewCancelPayments === true ?  
      (
        <LoanPaymentViewCancel setViewCancelPayments={setViewCancelPayments} selectedProductLoan={selectedProductLoan} selectedUser={selectedUser} setAlert={setAlert} setAlertOpen={setAlertOpen} />
      ) : viewPayments === true ?  
      (
        <LoanPaymentView setViewPayments={setViewPayments} selectedProductLoan={selectedProductLoan} selectedUser={selectedUser} setAlert={setAlert} />
      ) : viewReports === true ? 
      (
        <Box>
          <LoanUserReportsView setViewReports={setViewReports} selectedUser={selectedUser} />
        </Box>
      ) : viewLimitHistory === true ?  
      (
        <LoanLimitHistory setViewLimitHistory={setViewLimitHistory} selectedProductLoan={selectedProductLoan} selectedUser={selectedUser} />
      ) : viewPreQualificationScreening === true ?  
      (
        <PreQualificationScreening setViewPreQualificationScreening={setViewPreQualificationScreening} selectedProductLoan={selectedProductLoan} selectedUser={selectedUser} setAlertOpen={setAlertOpen} setAlert={setAlert} />
      ) :
      viewUnderwritingCreditAssessment === true ?  
      (
        <UnderwritingCreditAssessment setViewUnderwritingCreditAssessment={setViewUnderwritingCreditAssessment} selectedProductLoan={selectedProductLoan} selectedUser={selectedUser} setAlert={setAlert} setAlertOpen={setAlertOpen} />
      ) :
      viewApprovalLoanRequest === true ?  
      (
        <ApprovalLoanRequest setViewApprovalLoanRequest={setViewApprovalLoanRequest} selectedProductLoan={selectedProductLoan} selectedUser={selectedUser} setAlert={setAlert} setAlertOpen={setAlertOpen} />
      ) :
      viewLoanRequestDisbursement === true ?  
      (
        <LoanRequestDisbursement setViewLoanRequestDisbursement={setViewLoanRequestDisbursement} selectedProductLoan={selectedProductLoan} selectedUser={selectedUser} setAlert={setAlert} setAlertOpen={setAlertOpen} />
      ) :
      (
        <Box>
          <LoanProductsAssign
            products={products}
            selectedProductEligiblity={selectedProductEligiblity}
            maxAmtInputError={maxAmtInputError}
            handleEligiblityProductChange={handleEligiblityProductChange}
            errors={errors}
            maxEligibleAmt={maxEligibleAmt}
            handleMaxEligibleAmtChange={handleMaxEligibleAmtChange}
            handleMakeUserEligible={handleMakeUserEligible}
            viewReports={viewReports}
            setViewReports={setViewReports}
            isLoading={isLoading}
          />
          <LoanProductsAssignedTable
            setCreateNewLoan={setCreateNewLoan}
            setLoanAssignment={setLoanAssignment}
            productsAssignedToUsers={productsAssignedToUsers}
            handleLoanOptOut={handleLoanOptOut}
            handleMoreInfo={handleMoreInfo}
            setSelectedProductLoan={setSelectedProductLoan}
            setSelectedProductLoanId={setSelectedProductLoanId}
            setSelectedCurrencyCode={setSelectedCurrencyCode}
            handleApproveLoans={handleApproveLoans}
            handleApprovedLoans={handleApprovedLoans}
            setPayments={setPayments}
            setAlert={setAlert}
            getProductsAssignedToUsers={getProductsAssignedToUsers}
            setLoanType={setLoanType}
            handleLoanOptIn={handleLoanOptIn}
            setViewCancelPayments={setViewCancelPayments}
            setViewPayments={setViewPayments}
            setViewLimitHistory={setViewLimitHistory}
            setViewCancelledLoans={setViewCancelledLoans}
            setAlertOpen={setAlertOpen}
            setViewPreQualificationScreening={setViewPreQualificationScreening}
            setViewUnderwritingCreditAssessment={setViewUnderwritingCreditAssessment}
            setViewApprovalLoanRequest={setViewApprovalLoanRequest}
            setViewLoanRequestDisbursement={setViewLoanRequestDisbursement}
            setSelectedLoanProductArray={setSelectedLoanProductArray}
            setSelectedProductEligiblity={setSelectedProductEligiblity}
          />
        </Box>
      )}

      {/* BaseDrawer For Loan Details Info Drawer */}
      <BaseDrawer
        open={openLoanDetailsDrawer}
        handleClose={() => setOpenLoanDetailsDrawer(false)}
        height="85vh"
      >
        <LoanDetails4Pay />
      </BaseDrawer>

      {/* BaseDrawer For Loan Product Info Details */}
      <div className="loans-details-info-drawer">
        <BaseDrawer
          open={openLoanProductInfoDrawer}
          handleClose={() => setOpenLoanProductInfoDrawer(false)}
          height="85vh"
          className="loanProductInfoDrawer"
          overflow="auto"
        >
          <LoanProductInfo loanProductDetails={loanProductDetails} />
        </BaseDrawer>
      </div>

      {alert.severity !== "success" &&  
        <CustomAlert
          severity={alert.severity}
          show={alert.showAlert}
          header={alert.header}
          message={alert.message}
          onClick={() => {
            setAlert({ ...alert, showAlert: false });
          }}
          alertType={alert.alertType}
          confirmButton={alert.onConfirm}
          autoclose={alert.severity === "error" ? false : true}
        />
       } 

        <Box className="snackbar-container">
          {alert.severity == "success" && 
            <Snackbar 
              open={alertOpen} 
              autoHideDuration={4000} 
              onClose={handleClose} 
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right'
              }}
            >
              <Alert
                onClose={handleClose}
                severity="success"
                variant="filled"
                sx={{ width: '100%' }}
                autoHideDuration={null}
              >
                {alert.message}
              </Alert>
            </Snackbar>
          }
        </Box>
    </Box>
  );
}

export default LoansTab4Pay;
